var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopycomponent = function SvgCopycomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.667 3.167h-8c-.734 0-1.334.6-1.334 1.333v9.333h1.334V4.5h8V3.167Zm2 2.666H7.333C6.6 5.833 6 6.433 6 7.167V16.5c0 .733.6 1.333 1.333 1.333h7.334c.733 0 1.333-.6 1.333-1.333V7.167c0-.734-.6-1.334-1.333-1.334ZM7.333 16.5h7.334V7.167H7.333V16.5Z",
    fill: "current"
  })));
};
export default SvgCopycomponent;